import { baseThemeOptions } from './base-theme-options'

export const createTheme = (config = { responsiveFontSizes: false }) => {
  // Return the base theme options as a plain object.
  // responsiveFontSizes is no longer applied via MUI; responsive typography
  // is handled through the media queries already defined in baseThemeOptions.
  return { ...baseThemeOptions }
}
